import {
    MC,
    playSound,
    setupStage,
    waitForEvent,
} from "../../../animate/utils";
import { RevealGame } from "../RevealGame";

const SOUND = "Click";
const NUM_PIECES = 16;
const NUM_COVERS = 3;
export class BugsGame {
    private root: MC;
    private game: RevealGame;
    constructor(private frame: any) {}
    loaded = (mc: MC) => {
        this.root = mc;
        console.log("loaded space");
        (window as any).game = this.root;
        (window as any).frame = this.frame.root;
        setupStage(this.frame?.root, this.root);
        this.frame.toggleInner(false);
        this.game = new RevealGame(
            this.root,
            this.onSuccess,
            SOUND,
            NUM_PIECES,
            NUM_COVERS
        );
        this.game.start();
    };
    unload = () => {
        this.game && this.game.unload();
    };

    onSuccess = async () => {
        console.log("on success");
        this.root.gotoAndPlay(28);
        playSound("endBugs");
        await waitForEvent(this.root, "bugsEnd");
        this.game.start();
    };
}
